import { ICustomerPhoneRepository } from 'modules/authentication/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisCustomerPhoneRepository
  implements ICustomerPhoneRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public update: ICustomerPhoneRepository['update'] = async params => {
    await this.httpProvider.patch(`user/updatePhone/${params.customerId}`, {
      phone: params.phone,
    });
  };
}
